import { DeviceStatusTableComponent } from './../status-table/device-status-table.component';
import { TranslateModule } from '../../../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DeviceStatusPipeModule } from '../../../pipes/device-status-pipe.module';
import { MatTableModule, MatTooltipModule } from '@angular/material';

@NgModule({
  declarations: [DeviceStatusTableComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    MatTooltipModule,
    DeviceStatusPipeModule,
  ],
  exports: [
    DeviceStatusTableComponent
  ]
})
export class DeviceStatusTableModule { }
